import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "list-app" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "list-app__actions" }

import useVuelidate from '@vuelidate/core';
import { helpers, required, url } from '@vuelidate/validators';
import { ListApp, ListAppItem } from './models/ListApp';
import ContentHighlightsListItemEdit from './ContentHighlightsListItemEdit.vue';
import { PropType } from 'vue';
import { useVModel } from '@vueuse/core';
import VuelidateUtil from '@shared/util/vuelidateUtil';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentHighlightsListAppEdit',
  props: {
  modelValue: {
    type: Object as PropType<ListApp>,
    required: true,
  },
},
  emits: ["update:modelValue", "isInvalid"],
  setup(__props, { emit: __emit }) {

function onItemUpdate(item: ListAppItem, index: number) {
  value.value.items[index] = item;
  emit('isInvalid', $v.value.$invalid);
}

const props = __props;

const emit = __emit;
const value = useVModel(props, 'modelValue', emit);

const validations = {
  heading: { required },
};

const $v = useVuelidate(validations, value);

function markAsTouched(key: keyof ListApp) {
  const field = $v.value[key];
  if (field) {
    field.$touch();
  }
  emit('isInvalid', $v.value.$invalid);
}

function getErrorMessage(fieldName: string & keyof ListApp, label: string): string | null {
  return VuelidateUtil.getErrorMessage($v, fieldName, label);
}

function addItem() {
  value.value.items.push({
    url: '',
    description: '',
    label: '',
    image: '',
  });
  emit('isInvalid', $v.value.$invalid);
}

function removeItem(itemIndex: number) {
  if (value.value.items.length <= 1) {
    return;
  }
  value.value.items.splice(itemIndex, 1);
  emit('isInvalid', $v.value.$invalid);
}

return (_ctx: any,_cache: any) => {
  const _component_n_text_input = _resolveComponent("n-text-input")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_n_text_input, {
        modelValue: _unref(value).heading,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(value).heading) = $event)),
        label: "Heading",
        errorMessage: getErrorMessage('heading', 'Heading'),
        onInput: _cache[1] || (_cache[1] = () => markAsTouched('heading'))
      }, null, 8, ["modelValue", "errorMessage"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(value).items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "list-app__item"
      }, [
        _createVNode(ContentHighlightsListItemEdit, {
          "model-value": item,
          "item-index": index,
          "total-items": _unref(value).items.length,
          onRemove: ($event: any) => (removeItem(index)),
          "onUpdate:modelValue": onItemUpdate
        }, null, 8, ["model-value", "item-index", "total-items", "onRemove"])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_n_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            variant: "primary",
            onClick: addItem
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Add Item", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})